import { useCallback } from 'react';

import { useAccessibleAccounts } from 'shared/providers/AccessibleAccounts';

import { ActiveFilter } from '../Filter.types';
import { FORM_DICTIONARY } from '../FilterForm/FilterForm.constants';

export const useCurrentFilterOptions = () => {
  const { filters } = useAccessibleAccounts();

  return useCallback(
    (filedName: ActiveFilter) => {
      const filterName = FORM_DICTIONARY[filedName];

      return filters[filterName];
    },
    [filters]
  );
};
